/**
 * Appearance of the foreground elements in the navigation bar, i.e. the color of the menu, back, home button icons.
 *
 * - `dark` makes buttons **darker** to adjust for a mostly light nav bar.
 * - `light` makes buttons **lighter** to adjust for a mostly dark nav bar.
 */
export type NavigationBarButtonStyle = 'light' | 'dark';

/**
 * Visibility of the navigation bar.
 */
export type NavigationBarVisibility = 'visible' | 'hidden';

/**
 * Interaction behavior for the system navigation bar.
 * @deprecated This will be removed in a future release.
 */
export type NavigationBarBehavior = 'overlay-swipe' | 'inset-swipe' | 'inset-touch';

/**
 * Navigation bar positional mode.
 * @deprecated This will be removed in a future release.
 */
export type NavigationBarPosition = 'relative' | 'absolute';

/**
 * Current system UI visibility state. Due to platform constraints, this will return when the status bar visibility changes as well as the navigation bar.
 */
export type NavigationBarVisibilityEvent = {
  /**
   * Current navigation bar visibility.
   */
  visibility: NavigationBarVisibility;
  /**
   * Native Android system UI visibility state, returned from the native Android `setOnSystemUiVisibilityChangeListener` API.
   */
  rawVisibility: number;
};

/**
 * Navigation bar style.
 *
 * - `auto` will automatically adjust based on the current theme.
 * - `light` a light navigation bar with dark content.
 * - `dark` a dark navigation bar with light content.
 * - `inverted` the bar colors are inverted in relation to the current theme.
 */
export type NavigationBarStyle = 'auto' | 'inverted' | 'light' | 'dark';
